import { makeStyles } from "@material-ui/core/styles";

/**
 * スタイルHook.
 *
 * @type {object}
 */
const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(2, 5),
  },
  dialogActions: {
    padding: theme.spacing(3, 2, 2),
  },
}));

export default useStyles;
